/****************************************************************
 * WARNING THIS FILE IS AUTOGENERATED AND SHOULD NOT BE MODIFIED *
 ****************************************************************/
import * as React from "react"
import Svg from "@oui/system/Svg"
type DefaultProps = typeof defaultProps
type SvgProps = React.ComponentPropsWithoutRef<typeof Svg>
type Props = DefaultProps &
  Omit<SvgProps, "fill" | "height" | "stroke" | "viewBox" | "width">
const defaultProps = {
  label: "External Link",
  size: 20
}

const SvgExternalLink = ({ size, ...props }: Props) => (
  <Svg
    width={size}
    height={size}
    viewBox="0 0 20 20"
    fill="currentcolor"
    stroke="currentcolor"
    {...props}
  >
    <path d="M14 1.657L7.586 8.07l-.707-.707L13.243 1H10V0h5v5h-1V1.657zM1 3v11h11V7h1v8H0V2h8v1H1z" />
  </Svg>
)

SvgExternalLink.defaultProps = defaultProps
export default SvgExternalLink
